import { ResponsiveImage } from "@made-people/blueprint-responsive-image";
import { useSizeGuide } from "./use-size-guide";
import { useTranslate } from "@made-people/grease-translations";

interface InstructionStepProps {
  icon: {
    filename: string;
    alt?: string;
  };
  stepNumber: number;
  description: string;
}

const InstructionStep = ({
  icon,
  stepNumber,
  description,
}: InstructionStepProps) => {
  return (
    <div className="py-2 lg:py-6 flex flex-col">
      <ResponsiveImage
        initial={{
          src: icon.filename,
          alt: icon.alt || `Step ${stepNumber} Icon`,
        }}
        displaySize={{
          mobile: "100vw",
          tablet: "33vw",
          desktop: "33vw",
        }}
        className="rounded-lg overflow-hidden object-cover aspect-square"
      />
      <div className="flex items-center justify-center bg-[#383838] text-white rounded-full h-3 w-3 lg:w-5 lg:h-5 p-4 lg:p-6 my-4">
        <span>{stepNumber}</span>
      </div>
      <p>{description}</p>
    </div>
  );
};

export const MeasuringInstructions = () => {
  const sizeGuide = useSizeGuide();
  const translate = useTranslate();
  if (!sizeGuide) return null;

  return (
    <details id="how-to-measure" className="w-full group mb-4">
      <summary className="cursor-pointer p-4 bg-[#f5f5f5] rounded-lg flex items-center justify-between sticky top-1">
        <span className="font-medium">
          {translate("Size_Guide_How_To_Measure")}
        </span>
        <svg
          className="w-6 h-6 transition-transform duration-200 group-open:rotate-180"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </summary>
      <div className="mx-auto justify-items-center lg:grid grid-cols-3 w-full gap-4 pt-6 lg:pt-0">
        <InstructionStep
          icon={sizeGuide?.instructionIcons?.[0] ?? { filename: "" }}
          stepNumber={1}
          description={translate("Size_Guide_How_To_Measure_Step_1")}
        />
        <InstructionStep
          icon={sizeGuide?.instructionIcons?.[1] ?? { filename: "" }}
          stepNumber={2}
          description={translate("Size_Guide_How_To_Measure_Step_2")}
        />
        <InstructionStep
          icon={sizeGuide?.instructionIcons?.[2] ?? { filename: "" }}
          stepNumber={3}
          description={translate("Size_Guide_How_To_Measure_Step_3")}
        />
      </div>
    </details>
  );
};
